var config = {
    private: {}
};
config.oktaClientId = process.env.VUE_APP_OKTA_CLIENT_ID || '0oa3w64jucZtFo9Nn5d7';
config.oktaIssuer = 'https://jellyvision.okta.com';
config.baseUrl = process.env.VUE_APP_BASE_URL || 'http://localhost:8080';
config.apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:8082';
config.fileStorageUrl = process.env.FILE_STORAGE_URL || "https://s3.us-west-1.wasabisys.com/";

config.wasabiAccessKeyId = process.env.AWS_ACCESS_KEY_ID || "YD5AFFD9OO5O7N5QTQ2V";
config.wasabiSecretAccessKey = process.env.AWS_SECRET_ACCESS_KEY || "sOjeSE5zCp9AZp77nIWRDHEpgDpPTOr4YBdvmFcO";
config.wasabiRegion = process.env.AWS_DEFAULT_REGION || "us-west-1";
config.mediaUrlExpirationInSeconds = process.env.MEDIA_URL_EXPIRATION || 600;
config.apiKey = process.env.VUE_APP_API_KEY || "07a781d9658b41f787d06034adb9bf86";

export default config;